import React from "react";
import DashboardHeader from "../../../../components/dashboardHeader";
import { Grid } from "@mui/material";
import ChatList from "./ChatList";
import ChatBox from "./ChatBox";

const EducationChatWithAdminPage = () => {
  return (
    <DashboardHeader>
      <Grid container spacing={2} height={"80vh"}>
        <Grid item xs={12} md={3.5}>
          <ChatList />
        </Grid>
        <Grid item xs={12} md={8.5}>
          <ChatBox />
        </Grid>
      </Grid>
    </DashboardHeader>
  );
};

export default EducationChatWithAdminPage;
